Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobile = void 0;
var isMobile = function isMobile() {
  try {
    return window.screen.width < 840;
  } catch (error) {
    return false;
  }
};
exports.isMobile = isMobile;